<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>

<ng-container *ngIf="canAccessPlanFacturacionPanel || !accesoPanelEvaluado; else withOutAccessForm">

<div class="container-fluid py-4" data-testid="plan-page">
  <div class="title-header mb-3 mb-md-0">
    <div class="title-header__content">
      <div class="d-flex align-items-center flex-wrap mb-1">
        <h2 class="font-weight-bolder text-dark mb-0">Plan y Facturación</h2>
      </div>
      <p class="text-muted mb-0">Administra tu plan, consumo, vigencia, pagos, facturas, certificaciones y adicionales contratados.</p>
    </div>
    <div class="title-header__actions">
      <div class="pf-company-filter-wrap" *ngIf="rowsPlanes?.length > 1 && !hasReseller">
        <div class="pf-company-filter">
          <div class="pf-company-filter__label">
            <i class="fa-regular fa-layer-group"></i>
            <span>Planes</span>
          </div>
          <ng-select
            class="combo-empresa-pf"
            [items]="rowsPlanes"
            [clearable]="false"
            (change)="filtro($event)"
            placeholder="Seleccione Plan"
            bindLabel="nombrePlan"
            [(ngModel)]="planActual">
            <ng-template ng-label-tmp let-item="item">
              <span class="font-weight-semibold">{{ item.nombrePlan }}</span>
              <small class="text-muted ml-2">Vence: {{ item.fechaCaducidad | date:'dd/MM/yyyy' }}</small>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <div class="d-flex justify-content-between align-items-center w-100">
                <span class="font-weight-semibold">{{ item.nombrePlan }}</span>
                <span class="badge" [ngClass]="item.activo ? 'badge-light-success' : 'badge-light-secondary'">
                  {{ item.activo ? 'Activo' : 'Inactivo' }}
                </span>
              </div>
              <small class="text-muted d-block">Vigencia hasta {{ item.fechaCaducidad | date:'dd/MM/yyyy' }}</small>
            </ng-template>
          </ng-select>
        </div>
      </div>
         <button type="button" data-testid="plan-refresh"
              class="btn btn-outline-primary btn-sm pf-btn-refresh"
              [disabled]="loading"
              (click)="actualizarPanel()">
        <i class="fa-regular fa-rotate-right mr-1"></i> Actualizar vista
      </button>
    </div>
  </div>
  <div class="alert alert-warning d-flex align-items-center justify-content-between flex-wrap" *ngIf="paymentState?.isDemo">
    <div>
      <strong>Empresa en DEMO</strong>
      <span class="ml-2">hasta {{ paymentState?.trialEndDate | date:'dd/MM/yyyy' }}</span>
      <span class="ml-3">Último pago: <strong>{{ ultimoResultadoPagoTexto }}</strong></span>
    </div>
    <button type="button" class="btn btn-sm btn-primary mt-2 mt-md-0" (click)="payPlan(payPlanForm)">
      Reintentar pago
    </button>
  </div>
  <div class="row" *ngIf="planActual; else sinPlanArriba">
    <div class="col-12 mb-0">
      <div class="row">
        <div class="col-xl-3 col-lg-6 col-md-6 mb-4">
          <div class="card card-custom card-stretch pf-status-card pf-card-plan">
            <div class="card-body d-flex flex-column">
              <div class="d-flex align-items-center mb-3">
                <span class="pf-card-icon bg-primary mr-3">
                  <i class="fa-duotone fa-layer-group text-white"></i>
                </span>
                <div>
                  <span class="text-muted font-size-xs font-weight-bold text-uppercase">Plan Actual <span *ngIf="esPlanDemo" class="badge badge-warning ml-5 pf-badge-demo text-white">DEMO</span></span>
                  <br>
                  <span class="badge" [ngClass]="planActual.activo ? 'badge-light-success' : 'badge-light-danger'">
                    {{ planActual.activo ? 'Activo' : 'Inactivo' }}
                  </span>
                </div>
              </div>
              <h4 class="font-weight-bolder text-dark mb-1" data-testid="plan-current">{{ planActual.nombrePlan }}</h4>
              <div class="text-muted font-size-sm mb-auto">
                <span class="font-weight-bold text-dark">$ {{ planActual.pagoMensual | number:'1.0-0':'es-CL' }}</span> / mes
              </div>
              <button data-testid="action-change-plan"
                class="btn btn-sm mt-3 w-100"
                [ngClass]="puedeCambiarPlan ? 'btn-outline-primary cursor-pointer' : 'btn-outline-secondary cursor-default'"
                [disabled]="!puedeCambiarPlan"
                [ngbTooltip]="puedeCambiarPlan ? '' : 'No puedes cambiar de plan porque tu plan tiene deuda. Regulariza primero.'"
                (click)="puedeCambiarPlan && changePlan(changePlanForm)">
                <i class="fa-regular fa-bolt mr-1"></i> Cambiar Plan
              </button>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 col-md-6 mb-4" *ngIf="infoEstadoServicio as estadoSvc">
          <div class="card card-custom card-stretch pf-status-card" data-testid="service-status"
              [ngClass]="'pf-card-' + estadoSvc.colorClass">
            <div class="card-body d-flex flex-column">
              <div class="d-flex align-items-center mb-3">
                <span class="pf-card-icon mr-3"
                      [ngClass]="'bg-' + estadoSvc.colorClass">
                  <i class="fa-duotone fa-circle-check text-white"></i>
                </span>
                <div>
                  <span class="text-muted font-size-xs font-weight-bold text-uppercase">Estado del Servicio</span>
                  <br>
                  <span class="badge"
                        [ngClass]="'badge-light-' + estadoSvc.colorClass">
                    {{ estadoSvc.estado }}
                  </span>
                </div>
              </div>
              <p class="text-muted font-size-sm mb-auto">{{ estadoSvc.glosa }}</p>
              <button data-testid="action-regularize-plan"
                class="btn btn-sm mt-3 w-100"
                [ngClass]="puedeRegularizarPlan ? 'btn-danger cursor-pointer' : 'btn-outline-secondary cursor-default'"
                [disabled]="!puedeRegularizarPlan"
                [ngbTooltip]="tooltipRegularizarPlan"
                (click)="puedeRegularizarPlan && payPlan(payPlanForm)">
                <i class="fa-regular fa-rotate-right mr-1"></i> Regularizar
              </button>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 col-md-6 mb-4">
          <div class="card card-custom card-stretch pf-status-card pf-card-info" data-testid="plan-validity">
            <div class="card-body d-flex flex-column">
              <div class="d-flex align-items-center mb-3">
                <span class="pf-card-icon bg-info mr-3">
                  <i class="fa-duotone fa-calendar-days text-white"></i>
                </span>
                <div>
                  <span class="text-muted font-size-xs font-weight-bold text-uppercase">Vigencia</span>
                  <br>
                  <span class="badge" [ngClass]="diasRestantes > 30 ? 'badge-light-success' : diasRestantes > 7 ? 'badge-light-warning' : 'badge-light-danger'">
                    {{ diasRestantes }} días restantes
                  </span>
                </div>
              </div>
              <div class="mb-1">
                <span class="text-muted font-size-xs">Vence el</span>
                <div class="font-weight-bolder text-dark">{{ planActual.fechaCaducidad | date:'dd/MM/yyyy' }}</div>
              </div>
              <div class="text-muted font-size-xs mb-auto">
                Desde {{ planActual.fechaContratacion | date:'dd/MM/yyyy' }}
              </div>
              <button data-testid="action-extend-plan"
                class="btn btn-sm mt-3 w-100"
                [ngClass]="puedeExtenderPlan ? 'btn-outline-info cursor-pointer' : 'btn-outline-secondary cursor-default'"
                [disabled]="!puedeExtenderPlan"
                [ngbTooltip]="puedeExtenderPlan ? '' : 'No puedes extender porque tu plan tiene deuda. Regulariza primero.'"
                (click)="puedeExtenderPlan && extendPlan(extendPlanForm)">
                <i class="fa-duotone fa-sack-dollar mr-1"></i> Extender Plan
              </button>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 col-md-6 mb-4">
          <div class="card card-custom card-stretch pf-status-card" data-testid="monthly-usage"
              [ngClass]="usoEnRango ? 'pf-card-success' : 'pf-card-warning'">
            <div class="card-body d-flex flex-column">
              <div class="d-flex align-items-center mb-3">
                <span class="pf-card-icon mr-3"
                      [ngClass]="usoEnRango ? 'bg-success' : 'bg-warning'">
                  <i class="fa-duotone fa-gauge-high text-white"></i>
                </span>
                <div>
                  <span class="text-muted font-size-xs font-weight-bold text-uppercase">Uso del Mes</span>
                  <br>
                  <span class="badge" [ngClass]="usoEnRango ? 'badge-light-success' : 'badge-light-warning'">
                    {{ usoEnRango ? 'En rango' : 'Fuera de rango' }}
                  </span>
                </div>
              </div>
              <div class="mb-2">
                <div class="d-flex justify-content-between font-size-xs mb-1">
                  <span class="font-weight-bold">DTE</span>
                  <span class="text-muted" data-testid="plan-benefit-dte" [attr.data-limit]="planActual.maxDte">
                    {{ planActual.maxDte === -1 ? 'Ilimitado' : planActual.currentDte + ' / ' + planActual.maxDte }}
                    <span *ngIf="planActual.maxDte !== -1">({{ usoDtePorcentaje }}%)</span>
                  </span>
                </div>
                <div class="progress progress-xs" *ngIf="planActual.maxDte !== -1">
                  <div class="progress-bar"
                      [ngClass]="usoDtePorcentaje < 80 ? 'bg-success' : usoDtePorcentaje < 100 ? 'bg-warning' : 'bg-danger'"
                      [style.width.%]="usoDtePorcentaje"></div>
                </div>
              </div>
              <div class="mb-auto">
                <div class="d-flex justify-content-between font-size-xs mb-1">
                  <span class="font-weight-bold">BHE</span>
                  <span class="text-muted" data-testid="plan-benefit-bhe" [attr.data-limit]="planActual.maxBhe">
                    {{ planActual.maxBhe === -1 ? 'Ilimitado' : planActual.currentBhe + ' / ' + planActual.maxBhe }}
                    <span *ngIf="planActual.maxBhe !== -1">({{ usoBhePorcentaje }}%)</span>
                  </span>
                </div>
                <div class="progress progress-xs" *ngIf="planActual.maxBhe !== -1">
                  <div class="progress-bar"
                      [ngClass]="usoBhePorcentaje < 80 ? 'bg-success' : usoBhePorcentaje < 100 ? 'bg-warning' : 'bg-danger'"
                      [style.width.%]="usoBhePorcentaje"></div>
                </div>
              </div>
              <button class="btn btn-sm btn-outline-primary mt-3 w-100" (click)="activeTab = 'consumo'">
                <i class="fa-regular fa-chart-bar mr-1"></i> Ver detalle
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 mb-4">
      <app-deuda-adicional-card
        *ngIf="deudaAdicionalLoaded && tieneDeudaAdicionalPendiente"
        [deuda]="deudaAdicionalPendiente"
        [pagando]="pagandoDeudaAdicional"
        mensaje="El pago considera el total de la deuda pendiente. No se permiten pagos parciales."
        (pagar)="pagarDeudaAdicional()">
      </app-deuda-adicional-card>
      <!--PESTAÑAS-->
      <div class="card card-custom">
        <div class="card-body pt-4">

          <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav nav-tabs pf-nav-tabs"
              (navChange)="onTabChange($event.nextId)">

            <!--RESUMEN-->
            <li [ngbNavItem]="'resumen'">
              <a ngbNavLink data-testid="tab-resumen"><i class="fa-regular fa-house mr-1"></i> Resumen</a>
              <ng-template ngbNavContent>
                <div class="row mt-3">
                  <div class="col-lg-9 mb-4" *ngIf="chartOptions">
                    <div class="card card-custom shadow-none border">
                      <div class="card-body card-body__grafico p-3">
                        <apx-chart
                          [series]="chartOptions.series"
                          [chart]="chartOptions.chart"
                          [xaxis]="chartOptions.xaxis"
                          [dataLabels]="chartOptions.dataLabels"
                          [stroke]="chartOptions.stroke"
                          [title]="chartOptions.title">
                        </apx-chart>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3 mb-4">
                    <div class="card card-custom shadow-none border h-100">
                      <div class="card-header py-3">
                        <h6 class="card-title font-weight-bold mb-0">Acciones disponibles</h6>
                      </div>
                      <div class="card-body card-body__acciones d-flex flex-column justify-content-center">
                        <button data-testid="summary-action-extend-plan" class="btn btn-outline-info btn-sm mb-2 w-100 text-left"
                                [ngClass]="puedeExtenderPlan ? 'cursor-pointer' : 'cursor-default'"
                                [disabled]="!puedeExtenderPlan"
                                [ngbTooltip]="puedeExtenderPlan ? 'Extiende tu plan por meses adicionales' : 'No puedes extender porque tu plan tiene deuda. Regulariza primero.'"
                                (click)="puedeExtenderPlan && extendPlan(extendPlanForm)">
                          <i class="fa-duotone fa-sack-dollar mr-2"></i> Extender Plan
                        </button>
                        <button data-testid="summary-action-change-plan" class="btn btn-outline-primary btn-sm mb-2 w-100 text-left"
                                [ngClass]="puedeCambiarPlan ? 'cursor-pointer' : 'cursor-default'"
                                [disabled]="!puedeCambiarPlan"
                                [ngbTooltip]="puedeCambiarPlan ? '' : 'No puedes cambiar de plan porque tu plan tiene deuda. Regulariza primero.'"
                                (click)="puedeCambiarPlan && changePlan(changePlanForm)">
                          <i class="fa-regular fa-bolt mr-2"></i> Cambiar Plan
                        </button>
                        <button data-testid="summary-action-regularize-plan" class="btn btn-outline-danger btn-sm mb-2 w-100 text-left"
                                [disabled]="!puedeRegularizarPlan"
                                (click)="puedeRegularizarPlan && payPlan(payPlanForm)"
                                [ngbTooltip]="tooltipRegularizarPlan"
                                [ngClass]="puedeRegularizarPlan ? 'cursor-pointer' : 'cursor-default'">
                          <i class="fa-regular fa-rotate-right mr-2"></i> Regularizar Plan
                        </button>
                        <button data-testid="action-request-certification" class="btn btn-outline-warning btn-sm mb-2 w-100 text-left"
                                [ngClass]="esPlanDemo ? 'cursor-default' : 'cursor-pointer'"
                                [disabled]="esPlanDemo"
                                 [ngbTooltip]="esPlanDemo ? 'No puedes solicitar certificación en plan demo' : 'Solicita una certificación para tu empresa'"
                                (click)="buyCertifications(certificationsForm)">
                          <i class="fa-regular fa-certificate mr-2"></i> Solicitar Certificación
                        </button>
                        <button data-testid="action-contract-additional" class="btn btn-outline-success btn-sm w-100 text-left"
                            [ngClass]="esPlanDemo ? 'cursor-default' : 'cursor-pointer'"
                            [disabled]="esPlanDemo"
                            [ngbTooltip]="esPlanDemo ? 'No puedes solicitar adicional en plan demo' : 'Solicita un adicional para tu empresa'"
                            (click)="contratarAdicional(contratarAdicionalForm)">
                          <i class="fa-regular fa-circle-plus mr-2"></i> Contratar Adicional
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 mb-4">
                    <div class="card card-custom shadow-none border">
                      <div class="card-header py-3 d-flex align-items-center justify-content-between">
                        <h6 class="card-title font-weight-bold mb-0">Últimas Facturas</h6>
                        <button class="btn btn-sm btn-text btn-light-primary" (click)="activeTab = 'facturas'">
                          Ver todas
                        </button>
                      </div>
                      <div class="card-body p-0">
                        <div *ngIf="ultimasFacturas.length; else sinFacturas">
                          <table class="table table-sm table-hover mb-0 pf-table-spaced">
                            <thead class="thead-light">
                              <tr>
                                <th>Folio</th>
                                <th>Fecha</th>
                                <th>Total</th>
                                <th>Acción</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let f of ultimasFacturas">
                                <td class="font-weight-bold">{{ f.folio }}</td>
                                <td>{{ f.fechaEmision | date:'dd/MM/yy' }}</td>
                                <td>$ {{ f.total | number:'1.0-0':'es-CL' }}</td>
                                <td>
                                  <a class="btn btn-icon btn-sm btn-danger pf-btn-pdf-solid" title="Descargar PDF"
                                    (click)="openPDF(f.facturaId)">
                                  <fa-icon icon="file-pdf" class="fa-lg text-white"></fa-icon>
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <ng-template #sinFacturas>
                          <p class="text-muted text-center py-4 mb-0">No hay facturas registradas.</p>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 mb-4">
                    <div class="card card-custom shadow-none border">
                      <div class="card-header py-3 d-flex align-items-center justify-content-between">
                        <h6 class="card-title font-weight-bold mb-0">
                          Adicionales Vigentes
                          <span class="badge badge-primary ml-2">{{ adicionalesVigentes.length }}</span>
                        </h6>
                        <button class="btn btn-sm btn-text btn-light-primary" (click)="activeTab = 'adicionales'">
                          Ver todos
                        </button>
                      </div>
                      <div class="card-body p-0">
                        <div *ngIf="adicionalesVigentes.length; else sinAdicionales">
                          <table class="table table-sm table-hover mb-0 pf-table-spaced">
                            <thead class="thead-light">
                              <tr>
                                <th>Nombre</th>
                                <th>Inicio</th>
                                <th>Término</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let a of adicionalesVigentes">
                                <td class="font-weight-bold">{{ a.nombre }}</td>
                                <td>{{ a.fechaInicio | date:'dd/MM/yy' }}</td>
                                <td><span>{{ getAdicionalFechaTerminoTexto(a) }}</span></td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <ng-template #sinAdicionales>
                          <p class="text-muted text-center py-4 mb-0">No hay adicionales vigentes.</p>
                        </ng-template>
                      </div>
                    </div>
                  </div>

                </div>
              </ng-template>
            </li>

            <!--CONSUMO-->
            <li [ngbNavItem]="'consumo'">
              <a ngbNavLink data-testid="tab-consumo"><i class="fa-regular fa-chart-bar mr-1"></i> Consumo</a>
              <ng-template ngbNavContent>
                <div class="row mt-3">
                  <div class="col-lg-5 mb-4">
                    <div class="card card-custom shadow-none border h-100">
                      <div class="card-header py-3">
                        <h6 class="card-title font-weight-bold mb-0">Consumo del mes actual</h6>
                      </div>
                      <div class="card-body">
                        <div class="mb-4">
                          <div class="d-flex justify-content-between mb-2">
                            <span class="font-weight-bold">
                              <i class="fa-regular fa-file-invoice mr-2 text-primary"></i>Documentos Tributarios (DTE)
                            </span>
                            <span *ngIf="planActual.maxDte !== -1" class="font-weight-bolder text-dark">
                              {{ planActual.currentDte | number:'1.' }} / {{ planActual.maxDte | number:'1.' }}
                            </span>
                            <span *ngIf="planActual.maxDte === -1" class="badge badge-light-success">Ilimitado</span>
                          </div>
                          <div class="progress mb-1" style="height: 12px;" *ngIf="planActual.maxDte !== -1">
                            <div class="progress-bar"
                                [ngClass]="usoDtePorcentaje < 80 ? 'bg-success' : usoDtePorcentaje < 100 ? 'bg-warning' : 'bg-danger'"
                                [style.width.%]="usoDtePorcentaje"
                                role="progressbar">
                              {{ usoDtePorcentaje }}%
                            </div>
                          </div>
                          <small class="text-muted" *ngIf="planActual.maxDte !== -1">
                            {{ usoDtePorcentaje }}% utilizado
                            <span *ngIf="usoDtePorcentaje >= 80" class="text-warning font-weight-bold ml-2">
                              <i class="fa-solid fa-triangle-exclamation"></i> Límite próximo
                            </span>
                          </small>
                        </div>
                        <div class="mb-4">
                          <div class="d-flex justify-content-between mb-2">
                            <span class="font-weight-bold">
                              <i class="fa-regular fa-handshake mr-2 text-info"></i>Boletas de Honorarios (BHE)
                            </span>
                            <span *ngIf="planActual.maxBhe !== -1" class="font-weight-bolder text-dark">
                              {{ planActual.currentBhe | number:'1.' }} / {{ planActual.maxBhe | number:'1.' }}
                            </span>
                            <span *ngIf="planActual.maxBhe === -1" class="badge badge-light-success">Ilimitado</span>
                          </div>
                          <div class="progress mb-1" style="height: 12px;" *ngIf="planActual.maxBhe !== -1">
                            <div class="progress-bar"
                                [ngClass]="usoBhePorcentaje < 80 ? 'bg-info' : usoBhePorcentaje < 100 ? 'bg-warning' : 'bg-danger'"
                                [style.width.%]="usoBhePorcentaje"
                                role="progressbar">
                              {{ usoBhePorcentaje }}%
                            </div>
                          </div>
                          <small class="text-muted" *ngIf="planActual.maxBhe !== -1">
                            {{ usoBhePorcentaje }}% utilizado
                            <span *ngIf="usoBhePorcentaje >= 80" class="text-warning font-weight-bold ml-2">
                              <i class="fa-solid fa-triangle-exclamation"></i> Límite próximo
                            </span>
                          </small>
                        </div>
                        <div class="mb-2">
                          <div class="d-flex justify-content-between mb-2">
                            <span class="font-weight-bold">
                              <i class="fa-regular fa-users mr-2 text-success"></i>Usuarios
                            </span>
                            <span class="font-weight-bolder text-dark" data-testid="plan-benefit-users" [attr.data-limit]="planActual.maxUsuarios">{{ planActual.currentUsuarios }} / {{ planActual.maxUsuarios }}</span>
                          </div>
                          <div class="progress" style="height: 8px;">
                            <div class="progress-bar bg-success"
                                [style.width.%]="(planActual.currentUsuarios / planActual.maxUsuarios) * 100"
                                role="progressbar"></div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="col-lg-7 mb-4" *ngIf="chartOptions">
                    <div class="card card-custom shadow-none border h-100">
                      <div class="card-header py-3">
                        <h6 class="card-title font-weight-bold mb-0">Histórico de emisiones (últimos 6 meses)</h6>
                      </div>
                      <div class="card-body p-3">
                        <apx-chart
                          [series]="chartOptions.series"
                          [chart]="chartOptions.chart"
                          [xaxis]="chartOptions.xaxis"
                          [dataLabels]="chartOptions.dataLabels"
                          [stroke]="chartOptions.stroke"
                          [title]="chartOptions.title">
                        </apx-chart>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 mb-4">
                    <div class="card card-custom shadow-none border">
                      <div class="card-header py-3">
                        <h6 class="card-title font-weight-bold mb-0">Detalle mensual</h6>
                        <small class="text-muted d-block">Comparativo de uso vs. límite del plan.</small>
                      </div>
                      <div class="card-body p-0">
                        <div *ngIf="consumoDetalleMensual?.length; else sinDetalleConsumo">
                          <table class="table table-hover mb-0">
                            <thead class="thead-light">
                              <tr>
                                <th>Mes</th>
                                <th class="text-right">DTE emitidos</th>
                                <th class="text-right">Límite DTE</th>
                                <th class="text-right">% Uso DTE</th>
                                <th class="text-right">BHE emitidos</th>
                                <th class="text-right">% Uso BHE</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let row of consumoDetalleMensual">
                                <td class="font-weight-bold">{{ row.mes }}</td>
                                <td class="text-right">{{ row.dteEmitidos | number:'1.' }}</td>
                                <td class="text-right">
                                  <span *ngIf="row.limiteDte != null; else dteSinLimite">{{ row.limiteDte | number:'1.' }}</span>
                                  <ng-template #dteSinLimite>Ilimitado</ng-template>
                                </td>
                                <td class="text-right font-weight-bold">
                                  <span *ngIf="row.porcentajeDte != null; else porcentajeDteNA">
                                    {{ row.porcentajeDte }}%
                                    <i *ngIf="row.porcentajeDte >= 80" class="fa-solid fa-triangle-exclamation text-warning ml-1"></i>
                                  </span>
                                  <ng-template #porcentajeDteNA>—</ng-template>
                                </td>
                                <td class="text-right">{{ row.bheEmitidos | number:'1.' }}</td>
                                <td class="text-right">
                                  <span *ngIf="row.porcentajeBhe != null; else porcentajeBheNA">
                                    {{ row.porcentajeBhe }}%
                                    <i *ngIf="row.porcentajeBhe >= 80" class="fa-solid fa-triangle-exclamation text-warning ml-1"></i>
                                  </span>
                                  <ng-template #porcentajeBheNA>—</ng-template>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <ng-template #sinDetalleConsumo>
                          <p class="text-muted text-center py-4 mb-0">No hay detalle mensual para mostrar.</p>
                        </ng-template>
                      </div>
                    </div>
                  </div>

                </div>
              </ng-template>
            </li>

            <!--ADICIONALES-->
            <li [ngbNavItem]="'adicionales'">
              <a ngbNavLink data-testid="tab-adicionales">
                <i class="fa-regular fa-circle-plus mr-1"></i> Adicionales
                <span class="badge badge-primary ml-1" *ngIf="adicionalesVigentes.length">
                  {{ adicionalesVigentes.length }}
                </span>
              </a>
              <ng-template ngbNavContent *ngIf="esPlanDemo">
                <div class="text-center py-5">
                  <i class="fa-duotone fa-warning text-warning mb-3"></i>
                  <h6 class="font-weight-bold text-dark mb-2">Disponible solo con plan contratado (que no sea demo)</h6>
                  <p class="text-muted mb-4" style="max-width: 420px; margin: 0 auto 1.5rem;">
                   La contratación de Adicionales es exclusiva para empresas con un plan activo y pagado en SimpleFactura. Puedes contratar un plan desde la sección Plan Actual en la parte superior.
                  </p>
                </div>
              </ng-template>
              <ng-template ngbNavContent *ngIf="!esPlanDemo">
                <div class="mt-3">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <div>
                      <h6 class="font-weight-bold mb-0">
                        Adicionales contratados
                        <span class="text-muted font-weight-normal ml-2">({{ adicionales.length }} en total, {{ adicionalesVigentes.length }} vigentes)</span>
                      </h6>
                    </div>
                    <button class="btn btn-primary btn-sm" (click)="contratarAdicional(contratarAdicionalForm)">
                      <i class="fa-regular fa-circle-plus mr-1"></i> Contratar Adicional
                    </button>
                  </div>

                  <div class="card card-custom shadow-none border">
                    <div class="card-body p-0">
                      <div *ngIf="adicionales.length; else sinAdicionalesTab">
                        <table class="table table-hover mb-0 pf-table-spaced">
                          <thead class="thead-light">
                            <tr>
                              <th>Nombre</th>
                              <th>Descripción</th>
                              <th>Fecha Inicio</th>
                              <th>Fecha Término</th>
                              <th>Estado</th>
                            </tr>
                          </thead>
                          <tbody>
                              <tr *ngFor="let a of adicionales" [attr.data-testid]="'additional-row-' + a.idAdicional">
                                <td class="font-weight-bold" data-testid="additional-name">{{ a.nombre }}</td>
                                <td class="text-muted">{{ a.descripcion || '—' }}</td>
                                <td>{{ a.fechaInicio | date:'dd/MM/yyyy' }}</td>
                                <td data-testid="additional-expiration">
                                  <span>{{ getAdicionalFechaTerminoTexto(a) }}</span>
                                </td>
                                <td data-testid="additional-status">
                                <span [ngClass]="getAdicionalEstadoClass(a)">
                                  {{ getAdicionalEstadoTexto(a) }}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <ng-template #sinAdicionalesTab>
                        <div class="text-center py-5">
                          <i class="fa-duotone fa-inbox fa-3x text-muted mb-3"></i>
                          <p class="text-muted mb-2">No hay adicionales contratados.</p>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>

            <!--FACTURAS-->
            <li [ngbNavItem]="'facturas'">
              <a ngbNavLink data-testid="tab-facturas">
                <i class="fa-regular fa-file-invoice-dollar mr-1"></i> Facturas
                <span class="badge badge-primary ml-1" *ngIf="facturasPlan.length">{{ facturasPlan.length }}</span>
              </a>
              <ng-template ngbNavContent>
                <div class="mt-3">
                  <div class="row mb-3">
                    <div class="col-md-4">
                      <div class="input-group input-group-sm">
                        <div class="input-group-prepend">
                          <span class="input-group-text"><i class="fa-regular fa-search"></i></span>
                        </div>
                        <input type="text" class="form-control" placeholder="Buscar por folio..."
                              [(ngModel)]="filtroFolio" (ngModelChange)="onFiltrarFacturas()">
                      </div>
                    </div>
                    <div class="col-md-3">
                      <select class="form-control form-control-sm" [(ngModel)]="filtroEstado" (ngModelChange)="onFiltrarFacturas()">
                        <option value="">Todos los estados</option>
                        <option value="pagada">Pagadas</option>
                        <option value="pendiente">Pendientes</option>
                      </select>
                    </div>
                    <div class="col-md-5 text-right">
                      <small class="text-muted">
                        Mostrando {{ facturasFiltradas.length }} de {{ facturasPlan.length }} facturas
                      </small>
                    </div>
                  </div>

                  <div class="card card-custom shadow-none border">
                    <div class="card-body p-0">
                      <div *ngIf="facturasFiltradas.length; else sinFacturasTab">
                        <table class="table table-hover mb-0 pf-table-spaced">
                          <thead class="thead-light">
                            <tr>
                              <th>Folio</th>
                              <th>Fecha Emisión</th>
                              <th>Monto</th>
                              <th>Estado</th>
                              <th>Fecha de Pago</th>
                              <th class="text-center">Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let f of facturasPaginadas">
                              <td class="font-weight-bold">{{ f.folio }}</td>
                              <td>{{ f.fechaEmision | date:'dd/MM/yyyy' }}</td>
                              <td class="font-weight-bold">$ {{ f.total | number:'1.0-0':'es-CL' }}</td>
                              <td>
                                <span class="badge" [ngClass]="f.pagada ? 'badge-light-success' : 'badge-light-warning'">
                                  {{ f.pagada ? 'Pagada' : 'Pendiente' }}
                                </span>
                              </td>
                              <td>
                                <span *ngIf="f.fechaPago">{{ f.fechaPago | date:'dd/MM/yyyy HH:mm' }}</span>
                                <span *ngIf="!f.fechaPago" class="badge badge-light-secondary">Sin registrar</span>
                              </td>
                                <td class="text-center">
                                <button class="btn btn-icon btn-sm btn-danger pf-btn-pdf-solid" title="Descargar PDF"
                                        ngbTooltip="Descargar PDF" (click)="openPDF(f.facturaId)">
                                  <fa-icon icon="file-pdf" class="fa-lg text-white"></fa-icon>
                                </button>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <div class="d-flex justify-content-between align-items-center px-4 py-3 border-top" *ngIf="totalPaginasFacturas > 1">
                          <small class="text-muted">
                            Página {{ paginaFacturas + 1 }} de {{ totalPaginasFacturas }}
                          </small>
                          <div class="btn-group btn-group-sm">
                            <button class="btn btn-outline-secondary" [disabled]="paginaFacturas === 0"
                                    (click)="irPagina(paginaFacturas - 1)">
                              <i class="fa-regular fa-chevron-left"></i>
                            </button>
                            <button *ngFor="let p of paginasArray" class="btn"
                                    [ngClass]="p === paginaFacturas ? 'btn-primary' : 'btn-outline-secondary'"
                                    (click)="irPagina(p)">{{ p + 1 }}</button>
                            <button class="btn btn-outline-secondary"
                                    [disabled]="paginaFacturas === totalPaginasFacturas - 1"
                                    (click)="irPagina(paginaFacturas + 1)">
                              <i class="fa-regular fa-chevron-right"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                      <ng-template #sinFacturasTab>
                        <div class="text-center py-5">
                          <i class="fa-duotone fa-file-invoice fa-3x text-muted mb-3"></i>
                          <p class="text-muted mb-0">No se encontraron facturas con los filtros aplicados.</p>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </ng-template>
            </li>

            <!--CERTIFICACIONES-->
            <li [ngbNavItem]="'certificaciones'">
              <a ngbNavLink data-testid="tab-certificaciones"><i class="fa-regular fa-certificate mr-1"></i> Certificaciones</a>

              <ng-template ngbNavContent *ngIf="esPlanDemo">
                <div class="text-center py-5">
                  <i class="fa-duotone fa-warning text-warning mb-3"></i>
                  <h6 class="font-weight-bold text-dark mb-2">Disponible solo con plan contratado (que no sea demo)</h6>
                  <p class="text-muted mb-4" style="max-width: 420px; margin: 0 auto 1.5rem;">
                   La contratación de certificaciones es exclusiva para empresas con un plan activo y pagado en SimpleFactura. Puedes contratar un plan desde la sección Plan Actual en la parte superior.
                  </p>
                </div>
              </ng-template>
              <ng-template ngbNavContent *ngIf="!esPlanDemo">
                <div class="mt-3">
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h6 class="font-weight-bold mb-0">Certificaciones de tu empresa</h6>
                    <button class="btn btn-warning btn-sm" (click)="buyCertifications(certificationsForm)">
                      <i class="fa-regular fa-certificate mr-1"></i> Solicitar Certificación
                    </button>
                  </div>

                  <div *ngIf="!certificacionesTabLoaded" class="text-center py-4">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p class="text-muted mt-2">Cargando certificaciones...</p>
                  </div>

                  <div *ngIf="certificacionesTabLoaded">
                    <div *ngIf="certificacionesTab.length; else sinCertificaciones">
                      <div class="card card-custom shadow-none border">
                        <div class="table-responsive">
                          <table class="table table-hover mb-0 pf-cert-table">
                            <thead class="thead-light">
                              <tr>
                                <th>Fecha solicitud</th>
                                <th>Tipo</th>
                                <th>Código SII</th>
                                <th>Estado</th>
                                <th>Fecha Ult. Actualización</th>
                                <th class="text-center">Acciones</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let cert of certificacionesTab">
                                <td>
                                  <span *ngIf="cert.fechaSolicitud; else sinFechaSolicitud">
                                    {{ cert.fechaSolicitud | date:'dd/MM/yyyy' }}
                                  </span>
                                  <ng-template #sinFechaSolicitud>
                                    <span class="text-muted">Sin registro</span>
                                  </ng-template>
                                </td>
                                <td class="font-weight-bold">{{ cert.nombreCertificacion }}</td>
                                <td>{{ cert.codigoSii }}</td>
                                <td>
                                  <span class="badge" [ngClass]="getCertEstadoClass(cert.estadoId)">
                                    {{ cert.estadoNombre }}
                                  </span>
                                </td>
                                <td>
                                  <span *ngIf="cert.fechaFinalizacion; else sinFechaFin">
                                    {{ cert.fechaFinalizacion | date:'dd/MM/yyyy' }}
                                  </span>
                                  <ng-template #sinFechaFin>
                                    <span class="badge badge-light-secondary"> {{ cert.fechaSolicitud | date:'dd/MM/yyyy' }} </span>
                                  </ng-template>
                                </td>
                                <td class="text-center">
                                  <ng-container *ngIf="puedeGestionarInstructivo(cert); else sinAccionInstructivo">
                                    <button
                                      class="btn btn-icon btn-sm btn-outline-primary mr-1"
                                      ngbTooltip="Descargar instructivo"
                                      (click)="descargarInstructivo(cert)">
                                      <i class="fa-regular fa-download"></i>
                                    </button>
                                    <button
                                      class="btn btn-icon btn-sm btn-outline-info"
                                      ngbTooltip="Reenviar instructivo"
                                      (click)="reenviarInstructivo(cert)">
                                      <i class="fa-regular fa-paper-plane"></i>
                                    </button>
                                  </ng-container>
                                  <ng-template #sinAccionInstructivo>
                                    <span class="text-muted">No disponible</span>
                                  </ng-template>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <ng-template #sinCertificaciones>
                      <div class="text-center py-5">
                        <i class="fa-duotone fa-certificate fa-3x text-muted mb-3"></i>
                        <p class="text-muted mb-0">No hay certificaciones visibles para esta empresa en este momento.</p>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </ng-template>
            </li>

            <!--HISTORIAL-->
            <li [ngbNavItem]="'historial'">
              <a ngbNavLink data-testid="tab-historial"><i class="fa-regular fa-clock-rotate-left mr-1"></i> Historial</a>
              <ng-template ngbNavContent>
                <div class="mt-3">
                  <div class="card card-custom shadow-none border">
                    <div class="card-header py-3 d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <span class="pf-card-icon bg-primary mr-3">
                          <i class="fa-regular fa-clock-rotate-left text-primary"></i>
                        </span>
                        <div>
                          <h6 class="font-weight-bold mb-0">Historial de movimientos</h6>
                          <p class="text-muted mb-0 font-size-sm">Registro de actividad asociada a tu plan y empresa, ordenado del más reciente al más antiguo.</p>
                        </div>
                      </div>
                      <span class="badge badge-light-primary font-size-sm">
                        {{ historialItems.length }} evento{{ historialItems.length !== 1 ? 's' : '' }}
                      </span>
                    </div>
                    <div class="card-body">
                      <ng-container *ngIf="historialItems.length; else sinHistorial">
                        <div *ngIf="historialItems.length <= 7" class="pf-historial-timeline">
                          <ng-container *ngTemplateOutlet="tplHistorialCol; context: { items: historialItems }"></ng-container>
                        </div>
                        <div *ngIf="historialItems.length > 7" class="row">
                          <div class="col-md-6">
                            <div class="pf-historial-timeline">
                              <ng-container *ngTemplateOutlet="tplHistorialCol; context: { items: historialColumnas.izq }"></ng-container>
                            </div>
                          </div>
                          <div class="col-md-6 pf-historial-col-der">
                            <div class="pf-historial-timeline">
                              <ng-container *ngTemplateOutlet="tplHistorialCol; context: { items: historialColumnas.der }"></ng-container>
                            </div>
                          </div>
                        </div>

                      </ng-container>

                      <ng-template #sinHistorial>
                        <div class="text-center py-5">
                          <i class="fa-duotone fa-clock-rotate-left fa-3x text-muted mb-3"></i>
                          <p class="text-muted mb-0">No hay movimientos registrados aún.</p>
                        </div>
                      </ng-template>
                    </div>
                    <ng-template #tplHistorialCol let-items="items">
                      <div *ngFor="let item of items; let last = last"
                          class="pf-historial-item" [class.pf-historial-item--last]="last">

                        <div class="pf-historial-dot-wrap">
                          <span class="pf-historial-dot" [ngClass]="'bg-' + item.colorClass">
                            <i [class]="item.icono"></i>
                          </span>
                          <span *ngIf="!last" class="pf-historial-line"></span>
                        </div>

                        <div class="pf-historial-body">
                          <div class="d-flex align-items-start justify-content-between flex-wrap mb-1">
                            <div class="d-flex align-items-center flex-wrap">
                              <span class="font-weight-bolder text-dark mr-2">{{ item.titulo }}</span>
                              <span *ngIf="item.extra" class="badge ml-1" [ngClass]="'badge-light-' + item.extraClass">
                                {{ item.extra }}
                              </span>
                            </div>
                            <span class="text-muted font-size-xs ml-2 flex-shrink-0">
                              {{ item.fecha | date:'dd/MM/yyyy' }}
                            </span>
                          </div>
                          <p class="text-muted font-size-sm mb-0">{{ item.descripcion }}</p>
                        </div>

                      </div>
                    </ng-template>

                  </div>
                </div>
              </ng-template>
            </li>

          </ul>
          <div [ngbNavOutlet]="nav" class="pb-4"></div>
        </div>
      </div>
    </div>
  </div>
  <!-- Sin plan -->
  <ng-template #sinPlanArriba>
    <div class="card card-custom mb-4" *ngIf="!loading">
      <div class="card-body text-center py-5">
        <i class="fa-duotone fa-triangle-exclamation text-warning fa-3x mb-3"></i>
        <h5 class="font-weight-bold">No se encontró información del plan</h5>
        <p class="text-muted">No hay un plan activo asociado a tu empresa.</p>
      </div>
    </div>
  </ng-template>

</div> 

</ng-container>

<ng-template #withOutAccessForm>
  <div class="content-body py-6">
    <div class="row">
      <div class="col-12 col-lg-8 offset-lg-2">
        <div class="card card-custom">
          <div class="card-body">
            <h1 class="text-danger h2 mb-4">Sección disponible solo para el administrador principal</h1>
            <p>
              La sección Plan y Facturación solo puede ser gestionada por el usuario principal administrador de la cuenta.
            </p>
            <p class="mb-0">
              Para revisar el plan, realizar pagos o gestionar la facturación, debes ingresar con la cuenta del administrador principal.            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #payPlanForm let-d="dismiss" let-c="close">
  <div class="modal-xl">
    <div class="modal-header">
      <div class="modal-wizard-label">
        <div class="modal-wizard-title">Pago del Plan</div>
        <div class="modal-wizard-desc">Seleccione según corresponda</div>
      </div>
    </div>
    <div class="modal-body">
      <div class="row mt-4">
        <div class="col-8">
          <app-planes-bloque *ngIf="planActual && planes" [planes]="planes" [type]="'extend'" [planSeleccionado]="planSeleccionado" [planUsuario]="planActual" (actualizarPlan)="updatePlan($event)"></app-planes-bloque>
          <div class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark">
            <div class="card-body">
              <p class="mr-2">Datos para emisión de la factura:</p>
              <div *ngIf="datosFacturacion">
                <div class="row">
                  <div class="col-5">
                    <ng-select class="comboEmpresa" [items]="rowsDatosFacturacion" [clearable]="false" placeholder="Seleccione Empresa" bindLabel="razonSocial" [(ngModel)]="datosFacturacion"></ng-select>
                  </div>
                  <div class="col-7">
                    <div class="ml-4" style="display:flex">
                      <div>
                        <p>RUT: {{ datosFacturacion.rut }}-{{ datosFacturacion.dv }}</p>
                        <p>Comuna: {{ datosFacturacion.comuna }}</p>
                        <p>Giro: {{ datosFacturacion.giro }}</p>
                      </div>
                      <div class="ml-4">
                        <p>Razón Social: {{ datosFacturacion.razonSocial }}</p>
                        <p>Dirección: {{ datosFacturacion.dirFact }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="planActual" class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark">
            <div class="card-body" *ngIf="nuevaFechaCaducidad && nuevaFechaCaducidad.isBefore(fechaActual) && !resumenCuenta?.esReactivacion">
              <p>Tu plan actual terminó el {{ planActual.fechaCaducidad | date:'dd/MM/y' }}. Su nueva vigencia sería hasta el <strong>{{ nuevaFechaCaducidad.format('DD/MM/YYYY') }}</strong>.</p>
              <p *ngIf="nuevaFechaCaducidad.isBefore(fechaActual) && !resumenCuenta?.esReactivacion" style="color:red">Con este pago regularizas tu plan, pero aún mantendrías una mora de {{ nuevaFechaCaducidad.diff(fechaActual, 'days') * -1 }} días.</p>
            </div>
            <div class="card-body" *ngIf="nuevaFechaCaducidad && resumenCuenta?.esReactivacion">
              <p>Tu nueva vigencia comenzará con este pago y se extenderá hasta el <strong>{{ nuevaFechaCaducidad.format('DD/MM/YYYY') }}</strong>.</p>
            </div>
            <div class="card-body" *ngIf="nuevaFechaCaducidad && nuevaFechaCaducidad.isAfter(fechaActual) && !resumenCuenta?.esReactivacion">
              <p>Tu plan actual termina el {{ planActual.fechaCaducidad | date:'dd/MM/y' }}. Su nueva vigencia sería hasta el <strong>{{ nuevaFechaCaducidad.format('DD/MM/YYYY') }}</strong></p>
            </div>
          </div>
        </div>
        <div class="col-4">
          <app-resumen-bloque *ngIf="planActual && certificaciones" [planSeleccionado]="planSeleccionado" [certificaciones]="certificaciones" [type]="'extend'" [planUsuario]="planActual" (actualizarResumen)="notifyResumen($event)" [planes]="planes"></app-resumen-bloque>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div style="display:flex;align-items:center;flex-flow:row">
        <small>Si necesita emitir la factura a nombre de otra empresa, contacte con soporte antes de hacer el pago.</small>
        <button type="button" class="btn ml-4 btn-primary" (click)="pagar('payment')" id="pagarPlanSeleccionado">Pagar plan seleccionado</button>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #extendPlanForm let-d="dismiss" let-c="close">
  <div class="modal-xl" data-testid="extension-modal">
    <div class="modal-header">
      <div class="modal-wizard-label">
        <div class="modal-wizard-title">Extender Plan</div>
        <div class="modal-wizard-desc">Seleccione según corresponda</div>
      </div>
    </div>
    <div class="modal-body">
      <div class="row mt-4">
        <div class="col-8">
          <app-planes-bloque *ngIf="planActual && planes" [planes]="planes" [type]="'extend'" [planSeleccionado]="planSeleccionado" [planUsuario]="planActual" (actualizarPlan)="updatePlan($event)"></app-planes-bloque>
          <div class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark">
            <div class="card-body">
              <p class="mr-2">Datos para emisión de la factura:</p>
              <div *ngIf="datosFacturacion">
                <div class="row">
                  <div class="col-5">
                    <ng-select data-testid="extension-billing-rut" class="comboEmpresa" [items]="rowsDatosFacturacion" [clearable]="false" placeholder="Seleccione Empresa" bindLabel="razonSocial" [(ngModel)]="datosFacturacion"></ng-select>
                  </div>
                  <div class="col-7">
                    <div class="ml-4" style="display:flex">
                      <div>
                        <p>RUT: {{ datosFacturacion.rut }}-{{ datosFacturacion.dv }}</p>
                        <p>Comuna: {{ datosFacturacion.comuna }}</p>
                        <p>Giro: {{ datosFacturacion.giro }}</p>
                      </div>
                      <div class="ml-4">
                        <p>Razón Social: {{ datosFacturacion.razonSocial }}</p>
                        <p>Dirección: {{ datosFacturacion.dirFact }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="planActual" class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark">
            <div class="card-body" data-testid="extension-new-expiry" *ngIf="nuevaFechaCaducidad && nuevaFechaCaducidad.isBefore(fechaActual) && !resumenCuenta?.esReactivacion">
              Tu plan actual terminó el {{ planActual.fechaCaducidad | date:'dd/MM/y' }}. Su nueva vigencia sería hasta el <strong>{{ nuevaFechaCaducidad.format('DD/MM/YYYY') }}</strong>.
              <p *ngIf="nuevaFechaCaducidad.isBefore(fechaActual) && !resumenCuenta?.esReactivacion" style="color:red">Con este pago regularizas tu plan, pero aún mantendrías una mora de {{ nuevaFechaCaducidad.diff(fechaActual, 'days') * -1 }} días.</p>
            </div>
            <div class="card-body" data-testid="extension-new-expiry" *ngIf="nuevaFechaCaducidad && resumenCuenta?.esReactivacion">
              Tu nueva vigencia comenzará con este pago y se extenderá hasta el <strong>{{ nuevaFechaCaducidad.format('DD/MM/YYYY') }}</strong>.
            </div>
            <div class="card-body" data-testid="extension-new-expiry" *ngIf="nuevaFechaCaducidad && nuevaFechaCaducidad.isAfter(fechaActual) && !resumenCuenta?.esReactivacion">
              Tu plan actual termina el {{ planActual.fechaCaducidad | date:'dd/MM/y' }}. Su nueva vigencia sería hasta el <strong>{{ nuevaFechaCaducidad.format('DD/MM/YYYY') }}</strong>
            </div>
          </div>
          <div *ngIf="planActual && resumenCuenta && hasAdicionales" class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark">
            <div class="card-body" data-testid="extension-additional-start" *ngIf="resumenCuenta?.esReactivacion">Los adicionales agregados comenzarán con el nuevo pago y terminarán junto al plan.</div>
            <div class="card-body" data-testid="extension-additional-start" *ngIf="!resumenCuenta?.esReactivacion">Los adicionales agregados empezarán a funcionar el {{ planActual.fechaCaducidad | date:'dd/MM/y' }}.</div>
          </div>
          <div class="card-body card border-width-3 mt-3 border-radius-0 border-color-hover-dark">
            <div>Para transferencias:</div>
            <div>Banco BCI — Cuenta Corriente N° 97593249</div>
            <div>RUT: 78.181.331-1 — Chilesystems SPA</div>
            <div>pagos@chilesystems.com</div>
          </div>
        </div>
        <div class="col-4">
          <app-resumen-bloque *ngIf="planActual && certificaciones" [planSeleccionado]="planSeleccionado" [certificaciones]="certificaciones" [type]="'extend'" [planUsuario]="planActual" (actualizarResumen)="notifyResumen($event)" [planes]="planes" (actualizarCertificaciones)="actualizarCertificaciones($event)"></app-resumen-bloque>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div style="display:flex;align-items:center;flex-flow:row">
        <small>Si necesita emitir la factura a nombre de otra empresa, contacte con soporte antes de hacer el pago.</small>
        <button type="button" data-testid="extension-submit" class="btn ml-4 btn-primary" (click)="pagar('extend')" id="extenderPlan2">Extender Plan</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #changePlanForm let-d="dismiss" let-c="close">
  <div class="modal-xl" data-testid="change-modal">
    <div class="modal-header">
      <div class="modal-wizard-label">
        <div class="modal-wizard-title">Nuevo Plan</div>
        <div class="modal-wizard-desc">Seleccione según corresponda para la empresa {{ currentEmisorObject?.razonSocial }}</div>
      </div>
    </div>
    <div class="modal-body">
      <div class="row mt-4">
        <div class="col-8">
          <div *ngIf="downgradeRestringido && planActual?.nombrePlan !== 'Independiente'" data-testid="change-downgrade-warning" class="alert alert-warning d-flex align-items-start mb-3" role="alert" >
            <i class="fa-solid fa-triangle-exclamation mt-1 mr-3 text-white"></i>
            <div>
              <strong>Cambio a plan menor restringido</strong>
              <p class="mb-0 mt-1">Los planes de menor categoría solo pueden contratarse a partir del <strong>último mes de vigencia</strong> de tu plan actual. Podrás realizar el cambio desde el <strong data-testid="change-allowed-date">{{ fechaHabilitacionDowngrade }}</strong> en adelante.</p>
            </div>
          </div>
          <div *ngIf="!downgradeRestringido && planSeleccionado && isDowngrade(planSeleccionado) && planSeleccionado.id !== planActual?.idPlanSf" data-testid="change-downgrade-info" class="alert alert-primary d-flex align-items-start mb-3" role="alert">
            <i class="fa-solid fa-circle-info mt-1 mr-3 text-white"></i>
            <div>
              <strong>Información sobre el cambio de plan</strong>
              <ul class="mb-0 mt-1 pl-3">
                <li>Tu plan actual <strong>{{ planActual?.nombrePlan }}</strong> terminará <strong>inmediatamente</strong> al confirmar el cambio.</li>
                <li>El nuevo plan comenzará a regir desde hoy.</li>
                <li>No se aplica descuento por los días restantes del plan actual.</li>
              </ul>
            </div>
          </div>

          <app-planes-bloque
            *ngIf="planActual && planes"
            [planes]="planes"
            [type]="'change'"
            [planSeleccionado]="planSeleccionado"
            [planUsuario]="planActual"
            [planesNoSeleccionablesIds]="planesNoSeleccionablesIds"
            [downgradeRestringido]="downgradeRestringido"
            [fechaHabilitacionDowngrade]="fechaHabilitacionDowngrade"
            [precioActualPlan]="planActual.pagoMensual"
            (actualizarPlan)="updatePlan($event)">
          </app-planes-bloque>
          <div *ngIf="planActual" class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark">
            <div class="card-body" *ngIf="nuevaFechaCaducidad && nuevaFechaCaducidad.isAfter(fechaActual)">
              <p>Tu plan actual <b>{{ planActual.nombrePlan }}</b> termina el {{ planActual.fechaCaducidad | date:'dd/MM/y' }}.</p>
              <p *ngIf="mostrarGlosaNuevaVigenciaCambio" data-testid="change-validity-notice">
                Si confirmas este cambio, tu nuevo plan <strong>{{ planSeleccionado.nombre }}</strong> quedará vigente hasta el <strong>{{ nuevaFechaCaducidad.format('DD/MM/YYYY') }}</strong>.
              </p>
              <div *ngIf="mostrarGlosaNuevaVigenciaCambio && !isDowngrade(planSeleccionado)">
                <p *ngIf="resumenCuenta.mesesAbono > 0">El abono calculado es de <b>${{ resumenCuenta.abono | number:'1.0-0':'es' }} ({{ resumenCuenta.mesesAbono }} meses)</b>.</p>
                <p *ngIf="resumenCuenta.abono === 0">No existen meses completos no utilizados, por lo que se perderán los días restantes del plan <strong>{{ planActual.nombrePlan }}</strong> al cambiar a este nuevo plan.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-4">
          <app-resumen-bloque *ngIf="planActual && certificaciones" [planSeleccionado]="planSeleccionado" [certificaciones]="certificaciones" [type]="'change'" [planUsuario]="planActual" (actualizarResumen)="notifyResumen($event)" [planes]="planes" [planActualNuevo]="planActualNuevo"></app-resumen-bloque>
          <div class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark">
            <div class="card-body" *ngIf="datosFacturacion">
              <p class="card-title">Facturar al RUT: {{ datosFacturacion.rut }}-{{ datosFacturacion.dv }}</p>
              <ng-select data-testid="change-billing-rut" class="comboEmpresa" [items]="rowsDatosFacturacion" [clearable]="false" placeholder="Seleccione Empresa" bindLabel="razonSocial" [(ngModel)]="datosFacturacion"></ng-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div style="display:flex;align-items:center;flex-flow:row" *ngIf="planActual && planSeleccionado">
        <small>Si necesita emitir la factura a nombre de otra empresa, contacte con soporte antes de hacer el pago.</small>
        <button type="button" id="cambiarPlan" data-testid="change-submit" class="btn ml-4 btn-primary"
                [attr.aria-disabled]="isPlanNoSeleccionable(planSeleccionado) || (isDowngrade(planSeleccionado) && downgradeRestringido)"
                [ngClass]="{ 'disabled-link': isPlanNoSeleccionable(planSeleccionado) || (isDowngrade(planSeleccionado) && downgradeRestringido) }"
                [ngbTooltip]="isDowngrade(planSeleccionado) && downgradeRestringido ? 'El cambio a este plan estará disponible desde el ' + fechaHabilitacionDowngrade : ''"
                (click)="(isPlanNoSeleccionable(planSeleccionado) || (isDowngrade(planSeleccionado) && downgradeRestringido)) ? null : pagar('change')">Cambiar Plan</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #certificationsForm let-d="dismiss" let-c="close">
  <div class="modal-xl" data-testid="certification-modal">
    <div class="modal-header">
      <div class="modal-wizard-label">
        <div class="modal-wizard-title">Comprar Certificaciones</div>
        <div class="modal-wizard-desc">Seleccione las certificaciones que desea adquirir y los datos para facturación</div>
      </div>
    </div>
    <div class="modal-body">
      <div class="row mt-4">
        <div class="col-8">
          <div class="card border-width-3 border-radius-0 border-color-hover-dark mb-3">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-center mb-3">
                <p class="mr-2 m-0 font-weight-bold">Seleccione las certificaciones</p>
                <small class="text-muted">Las certificaciones deshabilitadas ya cuentan con folios o tienen certificaciones pendientes/realizadas</small>
              </div>
              <div *ngIf="certificaciones?.length; else emptyCerts">
                <div class="cert-list-container" style="position:relative">
                  <div *ngFor="let cert of certificaciones" class="d-flex align-items-center py-2 border-bottom">
                    <div class="custom-control custom-checkbox mr-3">
                      <input type="checkbox" class="custom-control-input" [id]="'certpf-' + cert.codigoPrincipal"
                             [attr.data-testid]="'certification-option-' + cert.codigoPrincipal"
                             [attr.data-eligibility]="cert.disabled ? 'disabled' : 'eligible'"
                             [(ngModel)]="cert.solicitada"
                             [disabled]="cert.disabled || certModalLoading || isCalculatingCerts"
                             (click)="onCertCheckboxClick($event)"
                             (change)="actualizarCertificaciones(certificaciones)"/>
                      <label class="custom-control-label" [for]="'certpf-' + cert.codigoPrincipal"></label>
                    </div>
                    <div class="flex-grow-1"><strong>{{ cert.nombre }}</strong></div>
                    <div class="text-right font-weight-bold" [attr.data-testid]="'certification-price-' + cert.codigoPrincipal" style="min-width:120px">$ {{ cert.valor | number:'1.0-0':'es' }}</div>
                  </div>
                  <div data-testid="certification-options-loading" *ngIf="certModalLoading || isCalculatingCerts" style="position:absolute;inset:0;background:rgba(255,255,255,0);z-index:50;cursor:progress"></div>
                </div>
              </div>
              <ng-template #emptyCerts><div class="text-muted">No hay certificaciones disponibles.</div></ng-template>
            </div>
          </div>
          <div class="card border-width-3 border-radius-0 border-color-hover-dark">
            <div class="card-body">
              <p class="card-title font-weight-bold mb-2">Datos para emisión de la factura:</p>
              <div *ngIf="datosFacturacion; else noBillingData">
                <ng-select data-testid="certification-billing-rut" class="comboEmpresa" [items]="rowsDatosFacturacion" [clearable]="false" placeholder="Seleccione Empresa" bindLabel="razonSocial" [(ngModel)]="datosFacturacion" (change)="recalcularResumenCertificaciones()"></ng-select>
                <div class="mt-3" style="display:flex">
                  <div>
                    <p class="m-0">RUT: {{ datosFacturacion.rut }}-{{ datosFacturacion.dv }}</p>
                    <p class="m-0">Comuna: {{ datosFacturacion.comuna }}</p>
                    <p class="m-0">Giro: {{ datosFacturacion.giro }}</p>
                  </div>
                  <div class="ml-4">
                    <p class="m-0">Razón Social: {{ datosFacturacion.razonSocial }}</p>
                    <p class="m-0">Dirección: {{ datosFacturacion.dirFact }}</p>
                  </div>
                </div>
              </div>
              <ng-template #noBillingData><div class="text-muted">No fue posible cargar los datos de facturación.</div></ng-template>
            </div>
          </div>
        </div>
        <div class="col-4">
          <app-resumen-bloque *ngIf="certificaciones" [planSeleccionado]="null" [certificaciones]="certificaciones" [type]="'certifications'" [planUsuario]="planActual" [planes]="null" [resumenExtern]="resumenCuenta" [modalLoading]="certModalLoading" (actualizarResumen)="notifyResumen($event)"></app-resumen-bloque>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div style="display:flex;align-items:center;flex-flow:row">
        <small>Si necesita emitir la factura a nombre de otra empresa, contacte con soporte antes de hacer el pago.</small>
        <button type="button" data-testid="certification-submit" class="btn ml-4 btn-primary" [disabled]="!hayCertificacionesSeleccionadas" (click)="pagar('certifications')" id="comprarCertificacionesConfirmPF">Comprar certificaciones seleccionadas</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #contratarAdicionalForm let-d="dismiss">
  <div class="modal-header" data-testid="additional-modal">
    <div class="modal-wizard-label">
      <div class="modal-wizard-title">Contratar Adicional</div>
      <div class="modal-wizard-desc">Seleccione los adicionales que desea contratar</div>
    </div>
    <button type="button" class="close" (click)="d('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row mt-2">
      <div class="col-lg-7">
        <div class="card border-width-3 border-radius-0 border-color-hover-dark mb-3">
          <div class="card-body p-0">
            <div *ngIf="adicionalesDisponibles.length; else todosContratados">
              <div *ngFor="let a of adicionalesDisponibles; let last = last"
                   class="d-flex align-items-center px-4 py-3"
                   [class.border-bottom]="!last">
                <div class="custom-control custom-checkbox mr-3">
                  <input type="checkbox"
                         class="custom-control-input"
                         [id]="'adic-pf-' + a.idAdicional"
                         [attr.data-testid]="'additional-option-' + a.idAdicional"
                         [attr.data-additional-name]="a.nombre"
                         [(ngModel)]="a.checked"
                         (ngModelChange)="cotizarAdicionales()"
                         [disabled]="a.readOnly"/>
                  <label class="custom-control-label" [for]="'adic-pf-' + a.idAdicional"></label>
                </div>
                <div class="flex-grow-1">
                  <div class="font-weight-bold">{{ a.nombre }}</div>
                  <small class="text-muted">{{ a.descripcion }}</small>
                  <div *ngIf="a.readOnly" class="mt-1">
                    <span class="badge badge-light-info">{{ a.message }}</span>
                  </div>
                </div>
                <div class="text-right font-weight-bold ml-3" style="min-width: 100px;">
                  <span *ngIf="a.precio > 0" [attr.data-testid]="'additional-monthly-price-' + a.idAdicional">$ {{ a.precio | number:'1.0-0':'es-CL' }} / mes</span>
                  <span *ngIf="a.precio === 0" class="badge badge-light-success">Gratis</span>
                </div>
              </div>
            </div>
            <ng-template #todosContratados>
              <div class="text-center py-5">
                <i class="fa-duotone fa-circle-check fa-3x text-success mb-3"></i>
                <p class="text-muted mb-0">Ya tienes todos los adicionales disponibles contratados.</p>
              </div>
            </ng-template>
          </div>
        </div>
        <div class="card border-width-3 border-radius-0 border-color-hover-dark" *ngIf="datosFacturacion">
          <div class="card-body">
            <p class="font-weight-bold mb-2">Datos para emisión de la factura:</p>
            <ng-select data-testid="additional-billing-rut" class="comboEmpresa" [items]="rowsDatosFacturacion" [clearable]="false"
                       placeholder="Seleccione Empresa" bindLabel="razonSocial"
                       [(ngModel)]="datosFacturacion">
            </ng-select>
            <div class="mt-3 d-flex">
              <div>
                <p class="m-0">RUT: {{ datosFacturacion.rut }}-{{ datosFacturacion.dv }}</p>
                <p class="m-0">Comuna: {{ datosFacturacion.comuna }}</p>
                <p class="m-0">Giro: {{ datosFacturacion.giro }}</p>
              </div>
              <div class="ml-4">
                <p class="m-0">Razón Social: {{ datosFacturacion.razonSocial }}</p>
                <p class="m-0">Dirección: {{ datosFacturacion.dirFact }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-5">
        <div class="card border-width-3 border-radius-0 border-color-hover-dark mb-3">
          <div class="card-header card-header--adicionales py-3">
             <h6 class="font-weight-bolder mb-1">Tiempo de contratación</h6>
          </div>
          <div class="card-body card-body--adicionales">
            <div class="text-muted" data-testid="additional-period" *ngIf="cotizacionAdicionales">
              Vigencia hasta {{ cotizacionAdicionales.fechaTermino | date:'dd/MM/yyyy' }}
              ({{ cotizacionAdicionales.diasCobrables }} días cobrables)
            </div>
            <div class="text-muted" *ngIf="!cotizacionAdicionales">Selecciona un adicional para cotizar.</div>
          </div>
        </div>
        <div class="card border-width-3 border-radius-0 border-color-hover-dark">
          <div class="card-header card-header--adicionales py-3">
            <h6 class="card-title font-weight-bold mb-0">Resumen</h6>
          </div>
          <div class="card-body pf-resumen-adicionales card-body--adicionales">
            <div *ngFor="let a of adicionalesChecked" class="d-flex justify-content-between mb-2">
              <span class="text-muted" style="font-size:0.875rem;">{{ a.nombre }}</span>
              <span class="font-weight-bold pf-resumen-adicionales__monto">
                <span *ngIf="a.precio > 0" [attr.data-testid]="'additional-prorated-price-' + a.idAdicional">$ {{ getMontoLineaAdicional(a) | number:'1.0-0':'es-CL' }}</span>
                <span *ngIf="a.precio === 0">$0</span>
              </span>
            </div>

            <hr *ngIf="adicionalesChecked.length" class="my-2"/>

			<app-saldo-favor-bloque
				*ngIf="totalAdicionalesCalc.total > 0"
				[total]="totalAdicionalesCalc.total"
				[maximoElegible]="totalAdicionalesCalc.neto"
				[planUsuario]="planActual"
				(seleccionChange)="actualizarSaldoAdicionales($event)"
			></app-saldo-favor-bloque>
            <div class="d-flex justify-content-between mb-1">
              <span>Neto</span>
              <span class="pf-resumen-adicionales__monto" data-testid="additional-net">$ {{ totalesAdicionalesConSaldo.neto | number:'1.0-0':'es-CL' }}</span>
            </div>
            <div class="d-flex justify-content-between mb-1 text-muted">
              <span>IVA (19%)</span>
              <span class="pf-resumen-adicionales__monto" data-testid="additional-vat">$ {{ totalesAdicionalesConSaldo.iva | number:'1.0-0':'es-CL' }}</span>
            </div>
            <hr class="my-2"/>
            <div class="d-flex justify-content-between font-weight-bolder">
              <span>Total a pagar</span>
              <span class="pf-resumen-adicionales__total" data-testid="additional-total">$ {{ diferenciaPagoAdicionales | number:'1.0-0':'es-CL' }}</span>
            </div>

            <div *ngIf="!hayAdicionalesSeleccionados" class="mt-3">
              <small class="text-muted">Seleccione al menos un adicional para continuar.</small>
            </div>
          </div>
        </div>

        <div class="card border-width-3 mt-3 border-radius-0 border-color-hover-dark">
          <div class="card-body card-body--adicionales">
            <small class="font-weight-bold d-block mb-1">Transferencia bancaria:</small>
            <small class="text-muted d-block">Banco BCI — Cta. Corriente N° 97593249</small>
            <small class="text-muted d-block">RUT: 78.181.331-1 — Chilesystems SPA</small>
            <small class="text-muted d-block">pagos@chilesystems.com</small>
          </div>
        </div>
      </div>

    </div>
  </div>
  <div class="modal-footer">
    <small class="mr-auto text-muted">Si necesita facturar a otra empresa, contacte a soporte antes de pagar.</small>
    <button type="button" class="btn btn-secondary mr-2" (click)="d('Cross click')">Cancelar</button>
    <button type="button" data-testid="additional-submit" class="btn btn-primary"
            [disabled]="!hayAdicionalesSeleccionados"
            (click)="ejecutarPagoAdicionales()">
      <i class="fa-regular mr-1" [ngClass]="esSoloPaykuSeleccionado ? 'fa-circle-check' : 'fa-credit-card'"></i>
	  {{ esSoloPaykuSeleccionado ? 'Confirmar' : (totalAdicionalesCalc.total > 0 ? (diferenciaPagoAdicionales === 0 ? 'Completar con saldo' : 'Pagar diferencia') : 'Activar Adicional') }}
    </button>
  </div>
</ng-template>

<ng-template #certificacionFechaForm let-d="dismiss" let-c="close">
  <div class="modal-header" data-testid="certification-date-modal">
    <div class="modal-wizard-label">
      <div class="modal-wizard-title">Fecha de Certificación</div>
    </div>
    <button type="button" class="close" (click)="d('Cross click')" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <label class="font-weight-bold mb-3">Seleccione la fecha de inicio del proceso:</label>
    <input type="date" data-testid="certification-date" class="form-control" [(ngModel)]="fechaCertificacion" [min]="fechaActual.format('YYYY-MM-DD')"/>
    <small class="text-muted d-block mt-2">La activación de las certificaciones se completará entre 3 a 5 días hábiles a partir de la fecha seleccionada.</small>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="d('Cross click')">Cancelar</button>
    <button type="button" data-testid="certification-date-confirm" class="btn btn-primary" [disabled]="!hayCertificacionesSeleccionadas" (click)="c('confirm')">Continuar</button>
  </div>
</ng-template>
